<template>
    <div>
        <ResultsLocationName :location="location" :rank="rank"/>
        <hp5-spacing-vertical xs="xxs"></hp5-spacing-vertical>
        <ResultsNetworkBannerContainer :result="location" :rank="rank" />
        <ResultsLocationInfo :location="location" :rank="rank" />
    </div>
</template>

<script setup>

    const props = defineProps({
        location: Object, 
        rank: Number
    })

</script>